









































import { Component, Vue, Watch } from "vue-property-decorator";
import MonitoringsService, { SocketChannels } from "./service";
import DButton from "@/components/DButton/button.vue";
import TableGrid from "@/components/TableGrid/grid.vue";
import { alert, confirm } from "devextreme/ui/dialog";
import AuthService from "@/services/auth_service";
import _ from "lodash";
import notifyService from "@/services/notify_service";
import WebSocketService from '@/services/websocket_service';
import {BackupSchedule} from "@/services/data/backup_schedule";


@Component({
  name: "ServiceMonitoring",
  components: {
    DButton,
    TableGrid,
  },
})
export default class extends Vue {
  public service = MonitoringsService;
  public authService = AuthService;

  public tableColumns: any[] = [];



  created() {
    this.initColumns();

    if (this.$options.sockets) {
      this.$options.sockets.onmessage = (data: any) => {

        let res = WebSocketService.handleMsg(data, SocketChannels.service_status);
        if (!_.isNil(res)) {
          this.service.dataSource.reload().catch((reason: any) => {});
        }
      }
    }

  }

  mounted() {

  }

  destroyed() {
    if (this.$options.sockets) {
      delete this.$options.sockets.onmessage
    }
  }

  get gridHeight() {
    return "100%";
  }

  public get user_mode(): boolean {
    return this.authService.isAdmin();
  }

  initColumns() {
    this.tableColumns = [
      {
        dataField: "id",
        visible: false,
      },
      {
        dataField: "name",
        caption: "Название сервиса",
        sortOrder: "asc",
      },
      {
        dataField: "description",
        caption: "Описание сервиса",
      },
      {
        dataField: "status",
        caption: "Статус сервиса",
        allowFiltering: false,
      },

    ];
  }

  private isManagement(e: any): boolean {
    return !e.row.data.not_management;
  }

  private isRunned(e: any): boolean {
    return e.row.data.status === 1;
  }

  empty() {
    //
  }

  onServiceStart(e: any) {
    confirm("Вы уверены, что хотите запустить сервис?", "Запуск сервиса").then(
      async (answer: boolean) => {
        if (!answer) {
          return;
        }

        try {
          const data: any = e.row ? e.row.data : e.data;
          this.service.post("start", data, 30000);
        } catch (e) {
          console.log(e);
        }

        this.service.selected_row = null;
      }
    );
  }

  onServiceStop(e: any) {
    const data: any = e.row ? e.row.data : e.data;

    if (data?.name === "tplus-saleform-api.service") {
      notifyService.error(
        "Запрещена остановка REST API сервера. Вы можете перезапустить сервис"
      );
      return;
    }

    confirm(
      "Вы уверены, что хотите остановить сервис?",
      "Остановка сервиса"
    ).then(async (answer: boolean) => {
      if (!answer) {
        return;
      }

      try {
        this.service.post("stop", data, 30000);
      } catch (e) {
        console.log(e);
      }
      this.service.selected_row = null;
    });
  }

  onServiceRestart(e: any) {
    confirm(
      "Вы уверены, что хотите перезапустить сервис?",
      "Перезапуск сервиса"
    ).then(async (answer: boolean) => {
      if (!answer) {
        return;
      }

      try {
        const data: any = e.row ? e.row.data : e.data;
        this.service.post("restart", data, 30000);
      } catch (e) {
        console.log(e);
      }
      this.service.selected_row = null;
    });
  }

  onRowClick(e: any) {
    this.service.selected_row = e.data;
  }

  // Изменение цвета фона ячейки в зависмости от значения статуса
  private customizeCell(e: any) {
    if (e.rowType !== "data" || e.column.dataField !== "status") {
      return;
    }

    if (e.value !== 0 && e.value !== 1) {
      e.cellElement.classList.add("status-cell_unknown");
    } else {
      e.cellElement.classList.add("status-cell_" + e.value);
    }

    switch (e.value) {
      case 1:
        e.cellElement.innerHTML = "Запущен";
        break;
      case 0:
        e.cellElement.innerHTML = "Остановлен";
        break;
      default:
        e.cellElement.innerHTML = "Данные отсутствуют";
        break;
    }
  }

  async onRefresh() {
    this.service.selected_row = null;
    await this.service.dataSource.reload();
  }

  onClose() {

  }


  onDelete() {
    confirm(
      "Вы уверены, что хотите удалить сервис из списка?",
      "Удаление сервиса"
    ).then(async (answer: boolean) => {
      if (!answer) {
        return;
      }

      try {
        await this.service.delete(this.service.selected_row);
        try {
          await this.service.dataSource.reload();
        } catch (e) {
          //
        }
        this.service.setCurrentRow(null);
      } catch (e) {
        console.log(e);
      }
    });
  }
}
